import { gameLaunch } from '@/api/game'
import { gameEnd } from '@/utils/games'
import store from '@/store'

const state = {
  noticeMessage: null,
  requestMessage: null,
  adMessage: null,
  toastMessage: null,
  errorMessage: null,
  loadCompleted: false,
  isLoading: true,
  loadingCount: 0,
  showGameWalletModal: false, // 存gameProviderId or false
  inGameId: null,
  leaveGamePath: '',
  hideMobileNav: false,
  gameUrl: '',
  gameIdsArray: JSON.parse(localStorage.getItem('gameIdsArray')) || [],
  isNeedCookie: false,
  isAgreeCookie: false,
  // 玩家是否已回應過 cookie 詢問(同意或不同意),回應後不再顯示;初始值由既有 cookie 判斷
  isCookieResponded: document.cookie.split('; ').some((item) => item.startsWith('isAgreeCookie=')),
  isModalActive: false,
  lastPopupTimeStamp: null,
  currentGame: {},
  isApiExecute: false,
  showCurrencyModal: false,
  pendingGameData: null,
  isCurrencyChangeInProgress: false,
  selectedWallet: {},
  walletSwitchRequest: null,
  // SEO meta（僅 theme_gold 於路由切換時寫入，見 main.js；需在 state 宣告才有響應性）
  metaInfo: null
}

const mutations = {
  SET_LOAD_COMPLETED(state, data) {
    state.loadCompleted = data
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading
  },
  SET_LOADING_COUNT_ZERO(state) {
    state.loadingCount = 0
  },
  SET_LOADING_COUNT_PLUS(state) {
    state.loadingCount += 1
  },
  SET_LOADING_COUNT_MINUS(state) {
    state.loadingCount -= 1
  },
  SET_NOTICE_MESSAGE(state, message) {
    state.noticeMessage = message
  },
  SET_REQUEST_MESSAGE(state, message) {
    state.requestMessage = message
  },
  SET_AD_MESSAGE(state, message) {
    state.adMessage = message
  },
  SET_API_EXECUTE(state, message) {
    state.isApiExecute = message
  },
  SET_TOAST_MESSAGE(state, message) {
    state.toastMessage = message
  },
  SET_GAME_WALLET_MODAL(state, data) {
    state.showGameWalletModal = data
  },
  SET_ERROR_MESSAGE(state, message) {
    state.errorMessage = message
  },
  SET_IN_GAME_ID(state, data) {
    state.inGameId = data
  },
  SET_GAME_URL(state, url) {
    state.gameUrl = url
  },
  SET_GAME_IDS_ARRAY(state, gameIdsArray) {
    state.gameIdsArray = gameIdsArray
    localStorage.setItem('gameIdsArray', JSON.stringify(gameIdsArray))
  },
  SET_LEAVE_GAME_PATH(state, data) {
    state.leaveGamePath = data
  },
  SET_ALERT(state, alert) {
    state.alert = alert
  },
  SET_HIDE_MOBILE_NAV(state, val) {
    state.hideMobileNav = val
  },
  CLEAR_GAME_IDS_ARRAY(state) {
    state.gameIdsArray = []
    localStorage.removeItem('gameIdsArray')
  },
  SET_COOKIE(state, val) {
    state.isNeedCookie = val
  },
  SET_IS_AGREE_COOKIE(state, val) {
    state.isAgreeCookie = val
  },
  SET_COOKIE_RESPONDED(state, val) {
    state.isCookieResponded = val
  },
  SET_MODAL_ACTIVE(state, value) {
    state.isModalActive = value
  },
  SET_CURRENT_GAME(state, value) {
    state.currentGame = value
  },
  SET_LAST_POPUP_TIMESTAMP(state, timestamp) {
    state.lastPopupTimeStamp = timestamp
  },
  CHANGE_META_INFO(state, metaInfo) {
    state.metaInfo = metaInfo
  },
  SET_CURRENCY_MODAL(state, value) {
    state.showCurrencyModal = value
  },
  SET_PENDING_GAME_DATA(state, data) {
    state.pendingGameData = data
  },
  SET_SELECTED_WALLET(state, data) {
    state.selectedWallet = data
  },
  SET_CURRENCY_CHANGE_IN_PROGRESS(state, value) {
    state.isCurrencyChangeInProgress = value
  },
  SET_WALLET_SWITCH_REQUEST(state, payload) {
    state.walletSwitchRequest = payload
  }
}

const actions = {
  launchGame({ commit, state }, { type, gameOrProvider, selectedCurrency }) {
    commit('SET_LOADING', true)
    commit('SET_CURRENT_GAME', gameOrProvider)

    let launchParams = {}

    launchParams = {
      type,
      wallet_type: state.selectedWallet.wallet_type,
      currency_in_game: selectedCurrency || gameOrProvider.currency_in_game,
      ...(type === 'provider'
        ? { game_provider_id: gameOrProvider.id }
        : { game_id: gameOrProvider.id })
    }

    return gameLaunch(launchParams).then(response => {
      const result = response.data.data
      const url = result.url
      commit('SET_IN_GAME_ID', result.game_id)
      commit('SET_LOADING', false)
      var newWindow = null
      if (gameOrProvider.game_open_type === 'iframe' || store.state.user.isFromDaily) {
        if (store.state.user.isFromChampionshipGame || store.state.user.isFromDaily) {
          commit('SET_GAME_URL', url)
          return
        }

        const currentTimeStamp = Math.floor(Date.now() / 1000)
        const gameModalPreferences = localStorage.getItem('gameModalPreferences')

        if (!state.lastPopupTimeStamp) {
          localStorage.setItem('lastPopupTimeStamp', currentTimeStamp.toString())
          if (!gameModalPreferences) {
            const gamePreferences = {}
            localStorage.setItem('gameModalPreferences', JSON.stringify(gamePreferences))
          }

          commit('SET_MODAL_ACTIVE', true)
          state.tempGameUrl = response.data.data.url
        }

        if (state.lastPopupTimeStamp) {
          if (!gameModalPreferences) {
            const gamePreferences = {}
            localStorage.setItem('gameModalPreferences', JSON.stringify(gamePreferences))
          }

          localStorage.setItem('lastPopupTimeStamp', currentTimeStamp.toString())
          commit('SET_LAST_POPUP_TIMESTAMP', currentTimeStamp)
          commit('SET_MODAL_ACTIVE', true)
          state.tempGameUrl = response.data.data.url
        }

        // Set the game URL after the modal has been prepared
        commit('SET_GAME_URL', url)
      } else if (gameOrProvider.game_open_type === 'new') {
        newWindow = window.open('/loading_game.html', '_blank')

        newWindow.location = url

        var startCheck = false

        // 偵測新視窗是否關閉
        var y = window.setInterval(function() {
          try {
            var newHost = newWindow.location.host
          } catch (e) {
            newHost = 'cross domain'
          }

          if (newHost !== window.location.host) {
            startCheck = true
          }

          if (newHost === window.location.host && startCheck) {
            // 新視窗回到包網
            newWindow.close()
            window.clearInterval(y)
            gameEnd(result.game_id)
          } else if (newWindow.closed) {
            // 新視窗已經關閉
            window.clearInterval(y)
            gameEnd(result.game_id)
          }
        }, 1000)
      } else {
        store.commit('SET_LOADING_COUNT_PLUS')
        window.location.href = url
      }
      // 搜尋遊戲所需，SearchGame.vue
      const gameIdsArray = state.gameIdsArray
      if (gameIdsArray.some(gameObj => gameObj.game_id === result.game_id)) {
        // Find the index of the existing game
        const existingGameIndex = gameIdsArray.findIndex(gameObj => gameObj.game_id === result.game_id)
        // Remove the existing game
        gameIdsArray.splice(existingGameIndex, 1)
      }
      gameIdsArray.push({ game_id: result.game_id })
      commit('SET_GAME_IDS_ARRAY', gameIdsArray)
    }).catch((error) => {
      console.log(error)
      commit('SET_GAME_URL', '')
      commit('SET_CURRENT_GAME', {})
    })
  }
}

export default {
  state,
  mutations,
  actions
}
